module.exports = __webpack_public_path__ + "media/images/redesign-images/careers/art/art-why-medium-ab4a12d6135154df877616d129358097.jpg";